// extracted by mini-css-extract-plugin
export default {"trackingEvents":"Jy-z","trackingEvent":"Ky-z","dailyEvent":"Ly-z","desciptionLocation":"My-z","time":"Ny-z","location":"Oy-z"};